import React from 'react';
import cn from 'classnames';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { Icon } from 'components';
import messages from '../messages';
import favoriteFill from 'assets/svg/favorite-fill.svg';
import './toggleFavoriteButton.scss';

interface OwnProps {
    isActive: boolean;
    toggle: () => void;
}

type Props = OwnProps & WrappedComponentProps;

class ToggleFavoriteButton extends React.Component<Props> {
    render() {
        const {
            isActive,
            toggle,
            intl: { formatMessage },
        } = this.props;

        const msg = isActive
            ? messages.removeFromFavorites
            : messages.addToFavorites;

        const title = formatMessage(msg);

        return (
            <div
                styleName="container"
                className="__app-ToggleFavoriteButton-container"
                onClick={toggle}
                title={title}
            >
                <Icon
                    styleName={cn('icon', {
                        ['is-active']: isActive,
                    })}
                    className={cn('__app-ToggleFavoriteButton-icon', {
                        ['__app-ToggleFavoriteButton-icon--is-active']: isActive,
                    })}
                    glyph={favoriteFill}
                />
            </div>
        );
    }
}

export default injectIntl(ToggleFavoriteButton);
